import styled from "styled-components";
// import { Link } from 'react-router-dom';
import { FaTwitter, FaLinkedinIn, FaGithub } from "react-icons/fa";
import { paddingV, paddingW } from "../constants";
import { useSelector } from "react-redux";

const SocialLinks = () => {
	const color = useSelector((state) => state.colorSlice.value);
	return (
		<Links color={color}>
			<a href="https://twitter.com/IMXNasr/" rel="noreferrer" target="_blank">
				<FaTwitter />
			</a>
			<a href="https://linkedin.com/in/imxnasr/" rel="noreferrer" target="_blank">
				<FaLinkedinIn />
			</a>
			<a href="https://github.com/IMXNasr" rel="noreferrer" target="_blank">
				<FaGithub />
			</a>
		</Links>
	);
};

export default SocialLinks;

const Links = styled.div`
	position: fixed;
	bottom: ${paddingV};
	left: ${paddingW};
	display: flex;
	flex-direction: column;
	row-gap: 1rem;
	z-index: 1;
	svg {
		font-size: 2rem;
		@media screen and (max-width: 500px) {
			font-size: 1.2rem;
		}
		transition: all 0.1s ease-out;
		&:hover {
			fill: ${(props) => props.color};
		}
	}
`;
